import React, { useCallback, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getDepositoNotasColumns } from './tanStackColumns';

const DEFAULT_HIDDEN_COLUMN_IDS = [
  'armazemEndereco',
  'localArmazenamento',
  'enderecoFormatado',
  'tipoOperacao',
  'pendencias',
  'nomeDestinatario',
  'nomeRemetente',
  'quantidadeTotalCaixas',
  'infoMotorista',
  'modelosReboque',
  'frotasReboque',
  'placasReboque',
  'chaveNFe'
];

const DEFAULT_COLUMN_VISIBILITY = DEFAULT_HIDDEN_COLUMN_IDS.reduce((visibility, columnId) => {
  visibility[columnId] = false;
  return visibility;
}, {});

const DepositoNotasTable = ({
  data,
  loading,
  totalRegistros,
  paginationState,
  setPaginationState,
  onRowClick,
  onAtualizar,
  loadingAtualizarId,
  onCadastrarDivergencia,
  onEnviarAnexo,
  onEnviarCanhoto,
  onVisualizarCanhoto,
  onAuditoria,
  onFinalizar,
  loadingAcao,
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled,
  rowTitleGetter,
  inlineEditConfig
}) => {
  const columns = useMemo(
    () => getDepositoNotasColumns(
      onAtualizar,
      loadingAtualizarId,
      onCadastrarDivergencia,
      onEnviarAnexo,
      onEnviarCanhoto,
      onVisualizarCanhoto,
      onAuditoria,
      onFinalizar,
      loadingAcao,
      selectedIds,
      onToggleSelect,
      onToggleSelectAll,
      allPageSelected,
      selectAllDisabled,
      inlineEditConfig
    ),
    [
      onAtualizar,
      loadingAtualizarId,
      onCadastrarDivergencia,
      onEnviarAnexo,
      onEnviarCanhoto,
      onVisualizarCanhoto,
      onAuditoria,
      onFinalizar,
      loadingAcao,
      selectedIds,
      onToggleSelect,
      onToggleSelectAll,
      allPageSelected,
      selectAllDisabled,
      inlineEditConfig
    ]
  );

  const handleRowClick = useCallback((row) => {
    if (onRowClick) onRowClick(row);
  }, [onRowClick]);

  const tableInitialState = useMemo(() => ({
    pageIndex: paginationState?.pageIndex || 0,
    pageSize: paginationState?.pageSize || 10,
    columnVisibility: DEFAULT_COLUMN_VISIBILITY
  }), [paginationState?.pageIndex, paginationState?.pageSize]);

  return (
    <Row>
      <Col md={12}>
        <TanStackTable
          columns={columns}
          data={data}
          onRowClick={handleRowClick}
          isSortable={true}
          withPagination={true}
          manualPagination={true}
          totalItems={totalRegistros}
          onPaginationChange={setPaginationState}
          controlledPagination={paginationState}
          pageSizeOptions={[10, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500]}
          initialState={tableInitialState}
          enableColumnConfig={true}
          columnConfigKey="deposito-notas-columns"
          enableExportExcel={true}
          exportFileName="deposito-notas-fiscais"
          enableColumnResizing={false}
          columnResizeMode="onChange"
          columnResizeDirection="ltr"
          enableRowColors={true}
          enableCopy={true}
          rowTitleGetter={rowTitleGetter}
          loading={!!loading}
          className="mt-3"
        />
      </Col>
    </Row>
  );
};

export default DepositoNotasTable;
